type UploadedImageLike = {
  name?: string;
  asset?: { name?: string };
  asset_id?: string;
  assetId?: string;
  folder_type?: string;
};

export const MAX_CHAT_MESSAGE_CHARS = 50000;

export const buildMessageWithAttachments = (
  message: string,
  uploadedImages?: UploadedImageLike[]
): string => {
  let messageString = message.trim();

  if (uploadedImages && uploadedImages.length > 0) {
    // File references only — name + asset_id + folder_type. The asset's text
    // description (extracted document content, etc.) is delivered to the agent
    // separately via the structured `uploaded_images` payload, NOT inlined
    // here. Inlining blew past the 50k char message cap on any document with
    // substantial extracted text (CSV, PDF, etc.).
    const filesXml = uploadedImages
      .map((image) => {
        const name = image?.name || image?.asset?.name || 'image';
        const assetId = image?.asset_id || image?.assetId || '';
        const folderType = image?.folder_type || '';
        return `<file name="${name}" asset_id="${assetId}" folder_type="${folderType}"/>`;
      })
      .join('');

    messageString += `<attachments>${filesXml}</attachments>`;
  }

  return messageString;
};

/** Validate the text actually sent to the API, including its attachment references. */
export const chatMessageLengthError = (message: string, uploadedImages?: UploadedImageLike[]): string | null => {
  const content = message.trim() || (uploadedImages?.length ? 'Images uploaded' : '');
  const length = buildMessageWithAttachments(content, uploadedImages).length;
  return length > MAX_CHAT_MESSAGE_CHARS
    ? `Message and attachment references are too long (${length.toLocaleString()} characters; limit ${MAX_CHAT_MESSAGE_CHARS.toLocaleString()}). Shorten the message or send fewer attachments.`
    : null;
};
